import {Injectable} from '@angular/core';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {GenericLinkedResource} from '@catcore/types/base';
import {extractDataFromModel} from '@catcore/utils';
import {GenericResourceService} from '@catfeatures/services/generic-resource.service';
import {FeaturePortConnectionService} from '@catmodules/models/feature-port/services/feature-port-connection.service';
import {FeaturePort, FeaturePortCreateInfo} from '@catmodules/models/feature-port/types';
import {PortConnectorUnitService} from '@catmodules/models/ports/services/port-connector-unit.service';
import {Port} from '@catmodules/models/ports/types';
import {Restangular} from 'ngx-restangular';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class FeaturePortService extends RestHttpService<any> {

  constructor(service: Restangular,
              private featurePortConnectionService: FeaturePortConnectionService,
              private portConnectorUnitService: PortConnectorUnitService,
              private genericResourceService: GenericResourceService) {
    super('feature-ports', service);
  }

  create(item: FeaturePortCreateInfo): Observable<any> {
    const payload = {
      port_connector_unit: item.portConnectorUnit._links.self.href,
      virtual: item.isVirtual,
    };

    return this.queryAll().post(payload);
  }

  extractPortConnections2(featurePort: FeaturePort): GenericLinkedResource[] {
    const lookupKey = 'port_connection_type2';
    const portConnection2 = extractDataFromModel<FeaturePort>(featurePort, lookupKey);
    if (portConnection2 instanceof Array) {
      return portConnection2;
    } else {
      return [portConnection2];
    }
  }

  extractPortConnections1(featurePort: FeaturePort): GenericLinkedResource[] {
    const lookupKey = 'port_connection_types1';
    return extractDataFromModel<FeaturePort>(featurePort, lookupKey);
  }

  hasIncomingPortConnection(featurePort: FeaturePort): boolean {
    return Object.keys(featurePort._links)
      .includes('port_connection_type2');
  }

  createVirtualPort(port: Port): Observable<FeaturePort> {
    return this.portConnectorUnitService
      .create({portModel: port})
      .mergeMap((item: any) => {
        const newFeaturePort: FeaturePortCreateInfo = {isVirtual: true, portConnectorUnit: item};
        return this.create(newFeaturePort);
      })
      ;
  }

  /**
   * Return a list of all FeaturePortConnection models and there properties for the provided FeaturePort
   *
   * @param {FeaturePort} featurePort
   * @returns {Observable<any>}
   */
  getPortConnections1(featurePort: FeaturePort): Observable<any> {
    const requests = [];
    this
      .extractPortConnections1(featurePort)
      .forEach((port: GenericLinkedResource) => {
        const handler = this.genericResourceService.findServiceForResource(port.href);
        requests.push(handler.getCurrent());

        if (!handler.isReady()) {
          handler.load();
        }
      })
    ;
    return Observable
      .forkJoin(requests)
      .map((a) => {
        console.log('safdsdf', a);
      })
      ;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/feature-port/services/feature-port.service.ts